<div class="wrapper">
  

        <app-navegacao></app-navegacao>
      
        <app-barra-lateral></app-barra-lateral>
      
        <div class="" [ngClass]="{ 'content-wrapper':  true } "> 
            <!-- Content Header (Page header) -->
            <app-cabecalho-conteudo 
              [titulo]="titulo" 
              [subtitulo]="subtitulo" 
              [conteudoCaminho]='conteudoCaminho'
              [conteudoId]='conteudoId'>
            </app-cabecalho-conteudo>
      
            <app-aviso-certificado></app-aviso-certificado>

            <!-- Main content -->
            <div class="content">
              <router-outlet></router-outlet>
            </div>
            <!-- /.content -->
        </div>

        <app-rodape></app-rodape>
      
</div>